import { Box, Skeleton, Typography, useTheme } from "@mui/material";
import { MonitoringCardProps } from "src/components/cards/custom/monitoring-card/MonitoringCard";
import { SenecEkpTheme } from "src/styles/ekp-theme/senecEkpTheme";

export type MonitoringCardTopValueProps = Pick<MonitoringCardProps, "topValue" | "topValueUnit" | "topTitle" | "isLoading"> & {
    error?: string;
};
export const MonitoringCardTopValue = ({ topValue, topTitle, topValueUnit, isLoading, error }: MonitoringCardTopValueProps) => {
    const theme: SenecEkpTheme = useTheme();
    const textColor = +topValue === 0 ? theme.palette.senecSecondary.neutralGray20 : "text.primary";
    return (
        <Box display={"flex"} alignItems={"baseline"} justifyContent={"left"}>
            {isLoading ? (
                <Skeleton
                    data-testid="skeleton-top-value"
                    variant="rounded"
                    sx={{ height: "37.5px", width: "75%", borderRadius: "12px", marginTop: "10px" }}
                />
            ) : (
                <>
                    {error ? (
                        <Typography
                            variant={"h1"}
                            sx={{
                                color: theme.palette.senecSecondary.neutralGray20,
                            }}
                            data-testid={"Monitoring-Card-TopValueError"}
                        >
                            {error}
                        </Typography>
                    ) : (
                        <>
                            <Typography
                                variant={"h1"}
                                noWrap
                                sx={{
                                    color: textColor,
                                    textTransform: "none",
                                }}
                                data-testid={`${topTitle}-card-topValue`}
                            >
                                {topValue}
                            </Typography>
                            <Typography
                                variant={"body1Responsive"}
                                sx={{
                                    color: textColor,
                                    textTransform: "none",
                                    ml: "4px",
                                    fontFamily: "Mark Pro, sans-serif",
                                    fontWeight: 500,
                                }}
                                data-testid={`${topTitle}-card-topValueUnit`}
                            >
                                {topValueUnit ? topValueUnit : "kWh"}
                            </Typography>
                        </>
                    )}
                </>
            )}
        </Box>
    );
};
